const HOURS_PER_DAY = 24;
const MIN_PER_HOUR = 60;
const SEC_PER_MIN = 60;
export const MS_IN_SECOND = 1000; //
export const SSR_STALE_TIME = 610000; // 10 minues and 10 seconds, because server caches pages for 10 minutes
export const SSR_STALE_TIME_SEC = 610; // 10 minues and 10 seconds, because server caches pages for 10 minutes

export const SNACKBAR_SHOW_TIME = 3200;
export const oneDayInSeconds = HOURS_PER_DAY * MIN_PER_HOUR * SEC_PER_MIN;

export const FAILED_AUTH_INDEX = -1;

export const NO_APP_ID = -1;

export const TWO = 2;

export const SIMILAR_APPS_AMOUNT_ON_APP_PAGE = 6;

export const MAX_OPTIONS_IN_SEARCH_COMBOBOX = 5;
export const MAX_HISTORY_OPTIONS_IN_SEARCH_COMBOBOX_WITH_QUERY = 2;

// backend has strict pageSize limit now, need to add next's back ip to app-catalog whitelist on prod
// default is so small to make it work on dev envs
export const DEFAULT_SPLIT_APPS_SITEMAP_PAGE_SIZE = 40;

export const DEFAULT_MOBILE_BREAKPOINT_PX = 480;

export const SEARCH_QUERY_MAX_LENGTH = 150;
export const MINIMUM_FOR_RATING =
  process.env.NODE_ENV === 'development' ? 0 : 5;
